import { render, staticRenderFns } from "./SettingsBrands.vue?vue&type=template&id=7fca4282&"
import script from "./SettingsBrands.vue?vue&type=script&lang=js&"
export * from "./SettingsBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports